import './TagStagingArea.scss';
import { Dispatch, SetStateAction } from 'react';
import { Spinner } from '@Components/Spinner';
import { StagedTag } from './StagedTag';
import { StagedTagData, TagData } from './utils';

interface TagStagingAreaProps {
  stagedTags: StagedTagData[];
  setStagedTags: Dispatch<SetStateAction<StagedTagData[]>>;
  isSending: boolean;
  openTagCreationModal: (tag: TagData, isEditMode: boolean) => void;
}

export const TagStagingArea = ({
  stagedTags,
  setStagedTags,
  isSending,
  openTagCreationModal
}: TagStagingAreaProps) => {
  // Nothing to stage and not mid-send: don't render the empty box so it takes no space.
  if (!isSending && stagedTags.length === 0) return undefined;

  return (
    <div className='tag-staging-area'>
      {isSending ? (
        <div className='staging-loading'>
          <Spinner />
        </div>
      ) : (
        <div className='tag-list'>
          {stagedTags.map((tag, i) => (
            <StagedTag
              key={i}
              tag={tag}
              tagIndex={i}
              openTagCreationModal={openTagCreationModal}
              setStagedTags={setStagedTags}
            />
          ))}
        </div>
      )}
    </div>
  );
};
